module.exports = __webpack_public_path__ + "assets/images/JMDUNFIT5000.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/JMDUNFIT5000.png
// module id = 1407
// module chunks = 1